export const BackBckpFeatureKey = 'bckp';

export interface EntityVolumetry {
    entityId: string;
    entityName: string;
    /** Key: "YYYY-MM", value: TB */
    monthly: { [monthKey: string]: number };
    /** Total TB across all loaded months */
    total?: number;
}

export interface AdminVolumetryWidget {
    currentTbytes: number;
    previousTbytes: number;
    variationPct: number | null;
    entityCount: number;
    since: string;
    until: string;
    periodLabel: string;
}

export interface IBackBckpState {
    // Widget
    widget: AdminVolumetryWidget | null;
    widgetIsLoading: boolean;
    widgetIsLoaded: boolean;
    widgetIsOups: boolean;

    // Detail table
    entities: EntityVolumetry[];
    months: string[];          // sorted "YYYY-MM" keys present in the data
    detailIsLoading: boolean;
    detailIsLoaded: boolean;
    detailIsOups: boolean;

    // Requested period for detail
    requestedMonths: number;
}

export const BackBckpInitialState: IBackBckpState = {
    widget: null,
    widgetIsLoading: false,
    widgetIsLoaded: false,
    widgetIsOups: false,

    entities: [],
    months: [],
    detailIsLoading: false,
    detailIsLoaded: false,
    detailIsOups: false,

    requestedMonths: 12
};
